// @ts-nocheck

import v4 from 'uuid/v4';

import networkActions from '../../../actions/network';
import { type CustomRouterHistory } from '../../../createHistory';
import { RouterActionTypes } from '../../../types/actions/router';
import { type StoreType } from '../../../types/redux';
import { type GenericAction } from '../../../types/redux';
import RoutesRedirectionFactory from '../../../utils/routes/RoutesRedirectionFactory';
import { fillTemporaryMPNotification } from '../actions/mp';
import { recomputeNextMPBasketState } from '../actions/mp';
import { MPStateActionTypes } from '../types/actions/mp';
import { MPRoutesActionTypes } from '../types/actions/routes';

const handledActionTypes = [
  MPRoutesActionTypes.OPEN_MP_VIEW,
  RouterActionTypes.ROUTE_HAS_CHANGED,
  MPStateActionTypes.CLAIM_REWARD,
  MPStateActionTypes.CLAIM_ALL_REWARDS,
  MPStateActionTypes.FLUSH_NOTIFICATIONS,
  MPStateActionTypes.REGISTER,
  MPStateActionTypes.UPDATE_STATE,
];

const MPMiddleware =
  (history: CustomRouterHistory) =>
  ({ dispatch }: StoreType) =>
  (next: (action: GenericAction) => unknown) =>
  async (action: GenericAction) => {
    if (handledActionTypes.indexOf(action.type) !== -1) {
      const { type: actionType, hooks: actionHooks } = action;

      if (actionType === MPRoutesActionTypes.OPEN_MP_VIEW) {
        dispatch(fillTemporaryMPNotification());

        history.push(RoutesRedirectionFactory.getMPRouteConfig());
      }

      if (action.type === MPStateActionTypes.CLAIM_ALL_REWARDS) {
        const { uuids } = action.payload;

        uuids.forEach((uuid) => {
          const uniqId = v4();

          dispatch(
            networkActions.send({
              monopoly: {
                method: 'claimReward',
                id: uniqId,
                params: {
                  uuid,
                },
              },
            }),
          );
        });
      }

      if (action.type === MPStateActionTypes.CLAIM_REWARD) {
        const uniqId = v4();

        dispatch(
          networkActions.send({
            monopoly: {
              method: 'claimReward',
              id: uniqId,
              params: {
                uuid: action.payload.uuid,
              },
            },
          }),
        );
      }

      if (action.type === MPStateActionTypes.FLUSH_NOTIFICATIONS) {
        const uniqId = v4();

        dispatch(
          networkActions.send({
            monopoly: {
              method: 'flushNotifications',
              id: uniqId,
            },
          }),
        );
      }

      if (actionType === MPStateActionTypes.REGISTER) {
        const uniqId = v4();
        const { onSuccess, onError } = actionHooks ?? {};

        dispatch(
          networkActions.send(
            {
              monopoly: {
                method: 'register',
                id: uniqId,
              },
            },
            {
              queryId: uniqId,
              hooks: {
                onSuccess,
                onError,
              },
            },
          ),
        );
      }

      if (actionType === MPStateActionTypes.UPDATE_STATE) {
        const nextedFlow = next(action);
        dispatch(recomputeNextMPBasketState());
        return nextedFlow;
      }
    }

    return next(action);
  };

export default MPMiddleware;
